<template lang="pug">
.notice
  .title
    div
      span 通知
      i.ivu-icon.ivu-icon-ios-more(@click='changeType()')
        div.delete-menu(v-show='menuShow' @click='deleteAllMessage()')
          Icon(type="ios-trash-outline")
          span 删除所有消息
    div(v-if='userInfo.type === "admin"')
      li(v-for='(v,index) in list',@click='fun_go(v);checkReaded(v);query();')
        div(v-if='v.isRead === 0')
          Badge(dot).badge
          i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.havebadge
        i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.notbadge(v-else-if='v.isRead === 1 && v.type === "分享资料" || v.type === "分享案例"')
        div(v-if='v.type==="分享资料"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text {{JSON.parse(v.content).userName}}给您分享了资料,已保存至"资料中心"中
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`资料名称：<b>${JSON.parse(v.content).dataName} </b>`')
        div(v-if='v.type==="分享案例"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text {{JSON.parse(v.content).userName}}给您分享了案例,已保存至"我的案例"中
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`案例名称：<b>${JSON.parse(v.content).caseName} </b>`')
    div(v-else)
      li(v-for='(v,index) in list',@click='fun_go(v);checkReaded(v);query();')
        div(v-if='v.isRead === 0')
          Badge(dot).badge
          i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont
        i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont(v-else)
        div(v-if='v.type==="老师评分"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text {{JSON.parse(v.content).notifyTheBoxContent}}
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
        div(v-if='v.type==="老师审核自定义案例"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text 您有新的案例待审核
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`案例名称：<b>${JSON.parse(v.content).caseName} </b>`')
        div(v-if='v.type==="密码重置提示"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text 密码重置提示
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text 用户ID : {{v.userId}}
        div(v-if='v.type==="分享资料"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text {{JSON.parse(v.content).userName}}给您分享了资料,已保存至"资料中心"中
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`资料名称：<b>${JSON.parse(v.content).dataName} </b>`')
        div(v-if='v.type==="分享案例"').type
          div.time {{standardTime(v.createdTime)}}
          div.content-text {{JSON.parse(v.content).userName}}给您分享了案例,已保存至"我的案例"中
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`案例名称：<b>${JSON.parse(v.content).caseName} </b>`')
</template>
<script>
import MyBus from "@/utils/main";
import dayjs from "dayjs";
export default {
  data() {
    return {
      userInfo: {
        src: "",
        name: "",
        type: ""
      },
      list: [],
      menuShow: false
    };
  },
  created() {
    this.getByCode();
    this.query();
    console.log(this);
  },
  methods: {
    fun_go(v) {
      MyBus.$emit("fun_notice");
      // 跳转到审核页面
      switch (v.type) {
        case "老师评分":
          this.$parent.$refs.topNav.pageIndex = 2;
          sessionStorage.setItem("pageIndex", 2);
          this.$router.push("/Teacher/reportManage");
          this.query();
          break;
        case "老师审核自定义案例":
          this.$parent.$refs.topNav.pageIndex = 5;
          sessionStorage.setItem("pageIndex", 5);
          this.$router.push("/Teacher/To_examine");
          this.query();
          break;
        case "分享资料":
          if (this.$role.role === "admin") {
            this.$parent.$refs.topNav.pageIndex = 4;
            sessionStorage.setItem("pageIndex", 4);
            this.$router.push("/Teacher/datacenter");
            this.checkReaded(v);
            this.query();
            break;
          }
          if (this.$role.role === "teacher") {
            this.$parent.$refs.topNav.pageIndex = 3;
            sessionStorage.setItem("pageIndex", 3);
            this.$router.push("/Teacher/datacenter");
            this.checkReaded(v);
            this.query();
          }
          break;
        case "分享案例":
          if (this.$role.role === "admin") {
            this.$parent.$refs.topNav.pageIndex = 5;
            sessionStorage.setItem("pageIndex", 5);
            this.$router.push("/Teacher/case");
            this.checkReaded(v);
            this.query();
            break;
          }
          if (this.$role.role === "teacher") {
            this.$parent.$refs.topNav.pageIndex = 4;
            sessionStorage.setItem("pageIndex", 4);
            this.$router.push("/Teacher/case");
            this.checkReaded(v);
            this.query();
          }
          break;
        default:
          break;
      }
    },
    query() {
      const adminData = {
        userId: this.$role.code,
        types: JSON.stringify(["分享资料", "分享案例"])
        // type: "外部通知"
      };
      const teacherData = {
        userId: this.$role.code
      };
      console.log(this);
      if (this.userInfo.type === "admin") {
        // console.log("111111");
        this.$http.listWithoutNotification(adminData).then(res => {
          if (res.data.success) {
            console.log(res.data);
            this.list = res.data.data.list;
          }
        });
      }
      if (this.userInfo.type === "teacher") {
        // console.log("222222");
        this.$http.listWithoutNotification(teacherData).then(res => {
          if (res.data.success) {
            console.log(res.data);
            this.list = res.data.data.list;
          }
        });
      }
    },
    getByCode() {
      this.$http
        .userInfo({ code: this.$role.code })
        .then(res => {
          // 新增对登录账户属性的判断,针对管理员教师学生做出type类型判断
          if (res.data.success) {
            console.log(res);
            this.userInfo.name = res.data.data.name;
            this.userInfo.src = res.data.data.headImagePath;
            if (res.data.data.admin === true) {
              this.userInfo.type = "admin";
            } else if (res.data.data.student === true) {
              this.userInfo.type = "student";
            } else if (res.data.data.teacher === true) {
              this.userInfo.type = "teacher";
            }
            console.log(this.userInfo);
          }
          this.query();
        })
        .catch(() => {
          this.$Message.error("服务器异常");
        });
    },
    checkReaded(v) {
      const data = {
        ids: [v.id]
      };
      data.ids = JSON.stringify(data.ids);
      this.$http.updateNotificationRead(data).then(res => {
        console.log(res);
      });
      this.query();
    },
    changeType() {
      this.menuShow = !this.menuShow;
      MyBus.$emit("change_mask");
    },
    deleteAllNotification() {
      this.$http.deleteAllNotification().then(res => {
        if (res.data.success) {
          this.$Message.success("删除成功");
          this.query();
        }
      });
    },
    deleteAllMessage() {
      // this.changeType();
      this.$Modal.confirm({
        title: "确定删除所有消息？",
        onOk: () => {
          this.deleteAllNotification();
        }
      });
    },
    standardTime(v) {
      return dayjs(v).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    MyBus.$on("isDelete", (e) => {
      this.menuShow = e;
   });
  }
};
</script>
<style lang="stylus" scoped>
.notice
  // position absolute
  min-width 854px
  min-height 626px
  background rgba(255, 255, 255, 1)
  border-radius 4px
  // left 256px
  // right 256px
  margin auto
  text-align left
  .title
    font-size 24px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    // max-height: 80vh;
    overflow auto
    line-height 30px
    padding 28px 32px 42px 32px
    .ivu-icon-ios-more
      float right
      position relative
      z-index 999
      cursor pointer
      .delete-menu
        position absolute
        right 0
        width 156px
        height 44px
        background rgba(255,255,255,1)
        box-shadow 0px 0px 6px 0px rgba(0,0,0,0.2)
        border-radius 4px
        z-index 999
        cursor pointer
        .ivu-icon-ios-trash-outline
          font-size 20px
          line-height 44px
          text-align initial
        span
          font-size 14px
          font-weight 400
          color rgba(42,46,54,0.8)
          line-height 44px
          margin-left 8px
    li
      position relative
    .notbadge
      color #508FF4
      font-size 24px
      position relative
      top -55px
    .badge
      top 24px
      left 25px
      position absolute
    .iconfont
      color #508FF4
      font-size 24px
      top 24px
      position absolute
      display block
      // position relative
      // top -55px
    // .ivu-badge-dot
    // top -50px
    .type
      display inline-block
      margin 24px
      width calc(100% - 80px)
      border-bottom 1px solid #dddddd
      margin-bottom 0
      margin-left 48px
      // cursor pointer
      .time
        font-size 12px
        font-family MicrosoftYaHeiUI
        color rgba(153, 153, 153, 1)
        line-height 15px
        margin-bottom 10px
      .content-text
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(79, 87, 102, 0.8)
        margin-bottom 24px
        line-height 18px
</style>
